import { useEffect } from 'react';

/**
 * Adds `is-visible` to every `.reveal` element inside `containerRef` the first
 * time it scrolls into view. One shared IntersectionObserver, and each element
 * is unobserved after it reveals, so nothing runs while scrolling afterwards.
 */
const useReveal = (containerRef) => {
  useEffect(() => {
    const root = containerRef.current;
    if (!root) return undefined;
    const items = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      items.forEach((el) => el.classList.add('is-visible'));
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [containerRef]);
};

export default useReveal;
